import React from 'react';
import './footer.css';


const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footerLeft'>
        <span className='footerName'>Avikal Singh</span>
        <span className='footerRole'>AI Engineer · ML Engineer · Data Scientist · Data Engineer · AWS Certified</span>
      </div>
      <span className='footerRight'>© 2026 Avikal Singh</span>
    </footer>
  );
};

export default Footer;
